import styled, { css } from "styled-components/macro";
import React from "react";

export interface IFieldTemplate {
  editabel?: boolean;
  disable?: boolean;
  active?: boolean;
  error?: boolean;
  errorText?: string;
  className?: string;
  [s: string]: any;
}

const getBoderColor = (props: IFieldTemplate) => {
  if (!props.editabel) return "transparent";
  if (props.disable) return "transparent";
  if (props.error) return "#FF6170";
  if (props.active) return "#12b7e7";
  return "rgba(9, 21, 38, 0.6)";
};
export const wrapStyles = css`
  position: relative;
  padding: 7px 10px;
  font-size: 16px;
  line-height: 22px;
  border: 2px solid ${getBoderColor};
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  ${(props) => (props.disable ? "pointer-events: none;" : null)}
`;

export const Wrap = styled.label`
  ${wrapStyles}
`;

export const Error = styled.div<{ error?: boolean }>`
  position: absolute;
  bottom: -20px;
  left: 0;
  font-size: 12px;
  line-height: 18px;
  padding: 0 8px;
  max-width: 100%;
  ${(props) => props.error && "color:#FF6170;"};
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const FieldTemplateWithError = React.forwardRef(
  (
    {
      children,
      className,
      errorText,
      ...props
    }: React.PropsWithChildren<IFieldTemplate>,
    ref
  ) => {
    return (
      <Wrap {...props} className={className} ref={ref}>
        {children || <>&nbsp;</>}
        {errorText && <Error error={props.error}>{errorText}</Error>}
      </Wrap>
    );
  }
);
FieldTemplateWithError.displayName = "FieldTemplateWithError";

export default FieldTemplateWithError;
